import lozad from "./Libraries/lozad";

export default function InitLazyLoad() {

    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();


    const sliderElement = document.querySelector('.image-slider')

    // exit early if no sliderElement is found
    if (!sliderElement) {
        return;
    }

    // trigger load of all sliderImages, because Chrome cannot load slideImages directly
    sliderElement.querySelectorAll('.lozad.image').forEach((sliderImageElement) => {
        observer.triggerLoad(sliderImageElement)
    });
}
